var map = {
	"./ar/common.json": [
		4129,
		129
	],
	"./ar/navbar.json": [
		2866,
		866
	],
	"./cn/common.json": [
		4715,
		715
	],
	"./cn/navbar.json": [
		3884,
		884
	],
	"./en/common.json": [
		1785,
		785
	],
	"./en/navbar.json": [
		5962,
		962
	],
	"./fr/common.json": [
		9944,
		944
	],
	"./fr/navbar.json": [
		5815,
		815
	],
	"./vi/common.json": [
		2451,
		451
	],
	"./vi/navbar.json": [
		1412,
		412
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 480;
module.exports = webpackAsyncContext;